import React, { useRef, useEffect } from "react";

interface BureauFilterProps {
    isOpen: boolean;
    onClose: () => void;
    selectedCategory?: string;
    onCategoryChange?: (category: string) => void;
    onClear?: () => void;
    categoryCounts?: Record<string, number>;
}

const categoryOptions = [
  { key: 'all', label: 'All' },
  { key: 'active-not-ack', label: 'Active - Unacknowledged' },
  { key: 'active-ack', label: 'Active - Acknowledged' },
  { key: 'not-active-not-ack', label: 'Inactive - Unacknowledged' },
];


const BureauFilter: React.FC<BureauFilterProps> = ({
    isOpen,
    onClose,
    selectedCategory,
    onCategoryChange,
    onClear,
    categoryCounts,
}) => {
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) { return null; }

    return (
        <div className="filter-dropdown" ref={dropdownRef}>
            <div className="filter-dropdown__content">
                <h4 className="filter-dropdown__title">Filter CSH Alarms</h4>
                
                <div className="filter-dropdown__form">
                    {/* Category Selection - only show if onCategoryChange is provided */}
                    {onCategoryChange && (
                        <div className="filter-dropdown__section">
                            <div className="filter-dropdown__checkboxes">
                                {(() => {
                                    const counts = categoryCounts ?? {};
                                    const countsLoaded = Object.values(counts).some(v => v > 0);
                                    const total = counts['all'] ?? 0;
                                    return categoryOptions.map(cat => (
                                        <label key={cat.key} className="filter-dropdown__checkbox-label">
                                            <input
                                                type="radio"
                                                name="category"
                                                checked={selectedCategory === cat.key}
                                                onMouseDown={e => { e.preventDefault(); }}
                                                onClick={() => {
                                                    if (onCategoryChange) {onCategoryChange(cat.key);}
                                                }}
                                                onChange={() => {
                                                    if (onCategoryChange) {onCategoryChange(cat.key);}
                                                }}
                                                className="filter-dropdown__checkbox"
                                            />
                                            <span className="filter-dropdown__checkbox-text">
                                                {cat.label}
                                                {countsLoaded ? (cat.key === 'all' ? ` (${total})` : (counts[cat.key] !== undefined ? ` (${counts[cat.key]})` : '')) : ''}
                                            </span>
                                        </label>
                                    ));
                                })()}
                            </div>
                        </div>
                    )}

                    
                </div>
            </div>
        </div>
    );
};

export default BureauFilter;
